import { DialogBoxActionButtonSxStyle } from "@/common/utils/constants";
import { EqAppBar, EqButton, EqDialog, EqIconButton } from "@equitable/equx";
import { appConfig } from "@/common/config/appConfig";
import { isUserAuthenticated } from "@/common/utils/helpers";
import { useFormContext } from "@/common/context/formContextProvider";
import { useLanguage } from "@/common/context/languageProvider";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import classes from "./EQ_AppBar.module.css";

interface AppBarProps {
  bgColor?: "primary" | "black" | "white" | "grayReverse" | "whiteReverse";
  rightText: string;
  rightTextColor:
    | "iconDefault"
    | "iconDark"
    | "iconDisabled"
    | "iconError"
    | "iconFunctional"
    | "iconInfo"
    | "iconNonFunctional"
    | "iconSubstitute"
    | "iconSuccess"
    | "iconWarning"
    | "iconWhite";

  logoOrientation: "horizontal" | "vertical";
  logoText: boolean;
  logoTextLang: "FR" | "EN";
}

const Eq_AppBar = ({
  logoText,
  logoTextLang,
  rightText,
}: AppBarProps) => {
  const { t } = useTranslation();
  const language = useLanguage();
  const { isFormDirty } = useFormContext();
  const [dialog, setDialog] = useState<boolean>(false);

  const handleNavigation = () => {
    if (isFormDirty) {
      setDialog(true);

      return;
    }

    window.location.replace(appConfig.EZCOMPLETE_DASHBOARD_URL);
  };

  return (
    <>
      <EqAppBar
        bgColor="surfacePrimaryDefault"
        logoText={logoText}
        logoTextLang={logoTextLang}
        mobileMenuClick={function Xo() {}}
        rightMobileIcon="Menu"
        upperLeft={[]}
        upperLeftMaxLimit={5}
        upperLeftSpace={2}
        upperRight={[
          <Box className={classes.EQButton} key={Math.random()}>
            {isUserAuthenticated() && <EqButton
              color="surfaceBrandDark"
              label={t("returnToDashboard")}
              leftIcon
              leftIconVal="ChevronLeft"
              rightIconVal=""
              rightIcon
              onClick={handleNavigation}
              size="medium"
              variant="text"
              role="button"
            />}
            <EqIconButton
              color="iconDefault"
              onClick={language.switchLanguage}
              btnIcon={rightText}
              stroke={0}
              aria-label={rightText}
            />
          </Box>,
        ]}
        upperRightMaxLimit={5}
        upperRightSpace={3}
      />
      {dialog && (
        <EqDialog
          actionButtons={[
            {
              onClick: () => setDialog(false),
              color: "surfacePrimaryDark",
              label: t("stayOnPage"),
              variant: "text",
              sx: DialogBoxActionButtonSxStyle,
            },
            {
              onClick: () => {
                window.location.replace(appConfig.EZCOMPLETE_DASHBOARD_URL);
                setDialog(false);
              },
              color: "surfaceErrorDefault",
              label: t("exit"),
              sx: DialogBoxActionButtonSxStyle,
            },
          ]}
          dialogActionsHorizontal
          dividers={false}
          onClose={() => {
            setDialog(false);
          }}
          open={dialog}
          rightButtonIcon="X"
          title={t("unsavedChanges")}
        >
          {t("unSavedAlertMessage")}
        </EqDialog>
      )}
    </>
  );
};

export default Eq_AppBar;